export type SiteNavigationKeyboardAction =
    | Readonly<{ type: "close" }>
    | Readonly<{ type: "focus"; index: number }>
    | Readonly<{ type: "openPanel" }>
    | null;

export function siteNavigationKeyboardAction(
    key: string,
    index: number,
    itemCount: number,
    hasChildren: boolean,
): SiteNavigationKeyboardAction {
    if (key === "Escape") return { type: "close" };
    if (key === "ArrowDown" && hasChildren) return { type: "openPanel" };
    if (itemCount < 1) return null;
    if (key === "ArrowRight") return { type: "focus", index: (index + 1) % itemCount };
    if (key === "ArrowLeft") return { type: "focus", index: (index - 1 + itemCount) % itemCount };
    if (key === "Home") return { type: "focus", index: 0 };
    if (key === "End") return { type: "focus", index: itemCount - 1 };

    return null;
}
